export const validateFormDictamenes = (form, enqueueSnackbar = () => {}) => {
  if (!form?.campus?.value) {
    enqueueSnackbar("Falta seleccionar un campus", {
      variant: "error",
      autoHideDuration: null,
    });
    return false;
  } else if (!form?.ciclo) {
    enqueueSnackbar("Falta llenar campo ciclo", {
      variant: "error",
      autoHideDuration: null,
    });
    return false;
  }
  return true;
};
